/** @module Enums */ /** typedoc */

export enum ReleaseStateEnum {
    Draft = 'Draft',
    ConfirmDraft = 'ConfirmDraft',
    PendingApproval = 'PendingApproval',
    Rejected = 'Rejected',
    PendingRelease = 'PendingRelease',
    Released = 'Released',
    PendingTakeDown = 'PendingTakeDown',
    PendingSelfPause = 'PendingSelfPause',
    TakenDown = 'TakenDown',
    Paused = 'Paused',
    PendingPause = 'PendingPause',
    SelfPaused = 'SelfPaused'
}
